export default __webpack_public_path__ + "static/media/m-link-instargram.63ab0d47.svg";